import React from "react";
import { useRawMaterialControl } from "../redux/ReduxContext";
import { Label } from "@fluentui/react-components";

const cardClass = "bg-white dark:bg-oi-dark-background p-4 mb-4 drop-shadow-md";
const fieldClassName =
    "h-10 w-full border border-gray-300 dark:border-gray-600 bg-primary-light dark:bg-primary-dark px-3 focus:outline-none min-w-[56px]";
const fieldLabelClass =
    "mb-1 block text-[11px] font-semibold text-primary-dark dark:text-primary-light whitespace-nowrap";

export default function RawMaterialSupplierInfo() {
    const { state, dispatch } = useRawMaterialControl();

    return (
        <div className={cardClass}>
            <h6 className="mb-3 text-sm font-bold">Supplier info</h6>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
                <div>
                    <Label className={fieldLabelClass}>Material code from supplier</Label>
                    <input
                        type="text"
                        className={fieldClassName}
                        value={state.supplierMaterialCode ?? ""}
                        onChange={(e) =>
                            dispatch({ type: "SET_FIELD", payload: { field: "supplierMaterialCode", value: e.target.value } })
                        }
                    />
                </div>
                <div>
                    <Label className={fieldLabelClass}>Batch number</Label>
                    <input
                        type="text"
                        className={fieldClassName}
                        value={state.batchNumber ?? ""}
                        onChange={(e) =>
                            dispatch({ type: "SET_FIELD", payload: { field: "batchNumber", value: e.target.value } })
                        }
                    />
                </div>
                <div>
                    <Label className={fieldLabelClass}>Reg.nr</Label>
                    <input
                        type="text"
                        className={fieldClassName}
                        value={state.regNr ?? ""}
                        onChange={(e) =>
                            dispatch({ type: "SET_FIELD", payload: { field: "regNr", value: e.target.value } })
                        }
                    />
                </div>
            </div>
        </div>
    );
}
